export default __webpack_public_path__ + "static/media/contact-banner.563b2942.jpg";